{
  "version": "v1.0.0",
  "date": "2026-06-26T14:02:01Z"
}
